document.addEventListener('DOMContentLoaded', () => {
    // Select all the FAQ sections on the page
    const faqSections = document.querySelectorAll('.faq-section-padding');

    faqSections.forEach(section => {
        // Within each section, select the FAQ items
        const faqItems = section.querySelectorAll('.faq-item');

        faqItems.forEach(item => {
            const question = item.querySelector('.faq-question');
            const answer = item.querySelector('.faq-answer');
            const toggle = item.querySelector('.faq-toggle');

            question.addEventListener('click', () => {
                // Check if the clicked FAQ item is already open
                const isOpen = answer.classList.contains('open');

                // Close all other FAQ items in the same section
                faqItems.forEach(otherItem => {
                    if (otherItem!== item) {
                        const otherAnswer = otherItem.querySelector('.faq-answer');
                        const otherToggle = otherItem.querySelector('.faq-toggle');
                        otherAnswer.classList.remove('open');
                        otherToggle.textContent = '+';
                    }
                });

                // Toggle the clicked FAQ item
                if (isOpen) {
                    answer.classList.remove('open');
                    toggle.textContent = '+';
                } else {
                    answer.classList.add('open');
                    toggle.textContent = '-';
                }
            });
        });
    });
});